<div class="alert-modal-container">
  <div class="close-icon ion-padding" (click)="closeModal()" style="display: flex;">
    <img class="arrow ion-padding" src="../../../../assets/images/right-arrow.svg" alt="">&nbsp;&nbsp;
    <p>Continue to itiamc.com</p>
  </div>
  <!-- Desktop -->
  <div class="message-container content-web-section">
    <div class="message-text pan-adhaar-desktop" [ngStyle]="{'display': flag === 1 ? 'block' : 'none'}"
      (click)="redirectTo(flag)">
    </div>

    <div class="message-text nomination-updation-desktop" [ngStyle]="{'display': flag === 2 ? 'block' : 'none'}"
      (click)="redirectTo(flag)">
    </div>

    <div class="message-text vigilance-banner-desktop" [ngStyle]="{'display': flag === 3 ? 'block' : 'none'}"
      (click)="redirectTo(flag)">
    </div>
  </div>

  <!-- Mobile -->
  <div class="message-container content-mobile-section">
    <div class="message-text pan-adhaar-mobile" [ngStyle]="{'display': flag === 1 ? 'block' : 'none'}"
      (click)="redirectTo(flag)"></div>

    <div class="message-text nomination-updation-mobile" [ngStyle]="{'display': flag === 2 ? 'block' : 'none'}"
      (click)="redirectTo(flag)"></div>

    <div class="message-text vigilance-banner-mobile" [ngStyle]="{'display': flag === 3 ? 'block' : 'none'}"
      (click)="redirectTo(flag)"></div>
  </div>
</div>